import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from 'app/server/services';
import { RoleType } from '../enums/role-type';
import { CurrentCareerService } from '../services/current-career.service';

export const AuthGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const authenticationService = inject(AuthenticationService);
	const _router = inject(Router);
	const currentUser = authenticationService.currentUserValue;
	const currentActiveCareer = inject(CurrentCareerService);

	if (currentUser) {
		// Wait for the user profile to finish loading from /api/auth/me if it hasn't loaded yet
		await authenticationService.waitForUserLoaded();
	}

	const currentActiveProfile = authenticationService.currentActiveProfile.value;

	if (currentUser && currentActiveProfile) {
		if (
			!authenticationService.currentActiveProfile.value ||
			(authenticationService.activeProfileId.value === RoleType.Trainee && !currentActiveCareer.currentCareerId.value)
		) {
			_router.navigate(['/authentication/login'], { queryParams: { returnUrl: state.url } });
		}

		return true;
	}

	// not logged in so redirect to login page with the return url
	// if one_time_token is present, let the login page handle it without overwriting
	if (route.queryParams['one_time_token']) {
		return false;
	}
	await _router.navigate(['/authentication/login'], { queryParams: { returnUrl: state.url } });
	return false;
};
